/**
 * Shared utility functions for Join Codes and batch operations.
 */

export function chunkArray<T>(items: T[], chunkSize: number = 500): T[][] {
  const result: T[][] = []
  for (let i = 0; i < items.length; i += chunkSize) {
    result.push(items.slice(i, i + chunkSize))
  }
  return result
}
